// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"8011a413","284":"b7bac2c4","846":"9e7001ee"}[chunkId] + ".chunk.css";
};